
const pic=[
    {
        id:1,
        title:'3D modeling - The Forbidden City',
        converImg: require("../components/Card/Builiding.jpg"),
        url: "/model"
        
    }

]
export default pic;